<template>
  <v-row>
    <v-col cols="12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :back="true"
        :readonly="true"
        :title="title"
      />
    </v-col>
  </v-row>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  components: {
    VuetifyTable,
  },
  props: {
    licenceId: { default: '' },
    id: { default: '' },
    action: { default: '' },
    message: { default: '' },
    type: { default: '' },
  },
  data: () => ({
    headers: [
      {
        text: 'Etapa',
        value: 'etapa',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha de Inicio',
        value: 'fecha_inicio',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha de FIn',
        value: 'fecha_fin',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Folios Utilizados',
        value: 'utilizados',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Folios Totales',
        value: 'total',
        align: 'left',
        sortable: true,
      },
    ],
    name: '',
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/licence/${this.licenceId}/cycles`;
    },
    title() {
      return `Ciclos de Licencia de <b>${this.name}</b>`;
    },
  },
  mounted() {
    window.axios.get(`/api/licences/${this.licenceId}`)
    .then((result) => {
      this.name = `${result.data.nombre} - (${result.data.codigo})`;
    });
  },
};
</script>
